import React from 'react';
import api from 'controllers/raymanAPI';

class IconLoader
{
    constructor(iconID)
    {
        this.isLoaded = false;
        this.cachedUrl = "";
        this.iconID = iconID;
    }

    async getUrl(){
        if(!this.isLoaded)                
        {
            this.cachedUrl = await api.procedures.items.icons.authDownloadURL(this.iconID);
            this.isLoaded = true;
        }
        return this.cachedUrl;
    }
}
async function getData()
{
    let indexed = {};

    let response = await api.procedures.items.icons.getAll();
    let data = await response.json();
    data.forEach(item => {
        indexed[item] = new IconLoader(item);
    })
    
    return {array: data, indexed: indexed};
}

const ItemIconsCtx = React.createContext({
    loading: true, 
    data: {
        array: [], 
        indexed: {}
    }
});

function ItemIconsCtxProvider(props)
{

    const [loading, setLoading] = React.useState(true);
    const [data, setData] = React.useState({array: [], indexed: []});

    React.useEffect(() => {
        getData().then(values => {
            setData(values);
            setLoading(false);
        });
    }, []);

    return <ItemIconsCtx.Provider value={{loading: loading, data: {...data}}} >
        {props.children}
        </ItemIconsCtx.Provider>
}

export {ItemIconsCtx, ItemIconsCtxProvider};